import "../scss/style.scss"

jQuery(document).ready(function ($) {
  'use strict';

  var $window = $(window),
      windowW = $window.width(),
      windowH = $window.height(),
      isInit = true,
      isTouchDevice = false;

  function changeHeight() {
    windowH = $window.height();
    var newWindowW = $window.width();

    if ( newWindowW != windowW || isInit ) {
      document.documentElement.style.setProperty('--vh', `${windowH * 0.01}px`)
      windowW = $window.width();
      isInit = false;
    }
  }

  changeHeight();
  var timer = false;
  $(window).on('resize', function() {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout( function() {
      windowW = $window.width(),
      windowH = $window.height();
      changeHeight();
    } , 100);
  });

  function detectTouchDevice() {
    if (window.ontouchstart === null) {
      $('body').addClass('is-touch');
      isTouchDevice = true;
    }
  }
  detectTouchDevice();

  function initSwiper() {
    if ( typeof Swiper === 'function' ) {
      const heroImg = new Swiper('#js-heroImg', {
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        speed: 1000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      });
    }
  }
  initSwiper();

  function areaModal() {
    $(document).on('click', '.js-openModal', function(e){
      e.preventDefault();
      const target = $(e.currentTarget).attr('href');
      $('body').addClass('is-modal-open');
      return false;
    });

    $(document).on('click', '.js-closeModal', function(e){
      e.preventDefault();
      $('body').removeClass('is-modal-open');
      return false;
    });
  }
  areaModal();

  function toggleButton() {
    // <button class="js-toggle" data-target="" data-class="" data-type="add|remove">Toggle</button>
    $('.js-toggle').on('click', function(e) {
      var target    = $(this).data('target');
      var className = $(this).data('class');
      var type      = $(this).data('type');
      var tagName   = $(this).prop("tagName");

      if ( type == 'add') {
        $(target).addClass(className);
      }
      else if ( type == 'remove') {
        $(target).removeClass(className);
      }
      else {
        $(target).toggleClass(className);
      }

      if ( tagName == 'A' ) {
        return false;
      }
    });
  }
  toggleButton();

  function playVideo() {
    $('.js-playVideo').on('click', function(e) {
      var video = this.nextElementSibling;
      $(this).addClass('is-hidden');
      if ( video.tagName == 'VIDEO' ) {
        video.play();
      }
      return false;
    });
  }
  playVideo();

  /**
   * タブ切り替え
   * ref. https://developer.mozilla.org/ja/docs/Web/Accessibility/ARIA/Roles/Tab_Role
   */
  function addTabEvents() {
    const tabs = document.querySelectorAll('.js-tab');

    // 各タブに click イベントハンドラーを追加します
    tabs.forEach(tab => {
      tab.addEventListener("click", changeTabs);
    });
  }
  addTabEvents();

  let targetTabId;
  function changeTabs(e) {
    e.preventDefault();
    e.stopPropagation();
    const target = e.target;

    // 複数回同じ処理が走らないように判定をする
    if (targetTabId === target.id) return;
    targetTabId = target.id;

    const parent = target.parentNode;
    const grandparent = parent.parentNode.parentNode;
    const isStep = target.id.includes('step');
    const node = isStep ? grandparent.parentNode : grandparent;

    // タブから現在すべての選択状態を取り除きます
    node.querySelectorAll('[aria-selected="true"]')
      .forEach(t => t.setAttribute("aria-selected", false));

    node.querySelectorAll(`#${target.id}`)
      .forEach(t => t.setAttribute("aria-selected", true));

    // すべてのタブパネルを非表示にします
    node.querySelectorAll('[role="tabpanel"]')
      .forEach(p => p.setAttribute("hidden", true));

    // 選択されたパネルを表示します
    node.querySelector(`#${target.getAttribute("aria-controls")}`)
      .removeAttribute("hidden");

    if (isStep) {
      // scroll-behavior: smooth; だとスクロールが途中で止まってしまう
      $('html').css('scroll-behavior', 'auto');
      $("html,body").animate({ scrollTop: $('#stepTabList').offset().top }, 200);
      setTimeout(() => {
        $('html').css('scroll-behavior', 'smooth');
      }, 200);
    }
  }

  function initObserver() {
    const elem = document.querySelectorAll('.js-reasonSec');
    const options = {
      rootMargin: '-50% 0px',
    };

    const setActive = (target) => {
      const id = target.id
      // console.log(id)
      if (id) {
        $('.js-reasonNav a[href="#'+id+'"]').addClass('is-active');

      } else {
        $('.js-reasonNav').removeClass('is-hidden');
      }
    };

    const removeActive = (target) => {
      const id = target.id
      if (id) {
        $('.js-reasonNav a[href="#'+id+'"]').removeClass('is-active');

      } else {
        $('.js-reasonNav').addClass('is-hidden');
      }
    };

    const callback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActive(entry.target);
        } else {
          removeActive(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);
    elem.forEach(el => {
      observer.observe(el);
    });
  }
  initObserver();

  function scrollToAnker() {
    var urlHash = location.hash;
    if(urlHash) {
      var target = $(urlHash);
      var offset = $('.rn22-header').height();
      var position = target.offset().top - offset;
      $(window).scrollTop(position);
    }
  }

  $(window).on('load', function() {
    $.when(
      scrollToAnker()
    ).done(function() {
      $('html').css('scroll-behavior', 'smooth');
    });
  });
});
